<template>
  <div id="app">
    <NavHeader/>
    <router-view :key="$route.fullPath"></router-view>
    <OctothorpeFooter/>
  </div>
</template>

<script>
import NavHeader from "./components/NavHeader";
import OctothorpeFooter from "./components/OctothorpeFooter";
export default {
  name: 'app',
  components: {OctothorpeFooter, NavHeader},
}
</script>
